<template>

    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            :query="false"
            :reset="false"
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-date-picker
              v-model="month"
              type="month"
              @input="$gjNoticeQuery"
              :clearable="false"
              width="120px"
          ></gj-date-picker>
          <template #right>
            <gj-tool-group
                help
                log @viewLog="viewLog"
            ></gj-tool-group>
          </template>
        </app-filter-group>
      </template>
      <template #table>
        <gj-table
            name="exchange-rate"
            adaptParent
            :data="tableData"
            :show-pagination="false"
            :loading="loading"
            :columns="columns">
          <template v-slot:customRate="{row}">
            <template v-if="row.currency === 'CNY'">1.0000</template>
            <template v-else>
              <gj-edit-input
                  :value="row.customRate"
                  :item="row"

                  table-cell-edit
                  :on-confirm="updateMyExchangeRate"
                  :pop-title="'我的汇率'"
                  height="32px"
              ></gj-edit-input>
            </template>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
    import {getExchangeRatePage, updateCustomRate} from "../../../../api/system";
    import {isMeaningful, isMeaningless} from "../../../../utils/common";
    import {queryMixin, responseMixin} from "../../../../minxins";
    import {convertToMonth} from "../../../../utils/date.util";
    import {RE} from "../../../../utils/const";

  export default {
    name: "app-exchange-rate",
    mixins: [queryMixin, responseMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'currencyName', header: '币种名称', field: 'currencyName', width: '200px'},
          {id: 'currency', header: '币种代码', field: 'currency', width: '200px'},
          {id: 'currencySymbol', header: '币种符号', field: 'currencySymbol', width: '150px'},
          {id: 'referenceRate', header: '官方汇率', field: 'referenceRate', width: '150px'},
          {id: 'customRate', header: '我的汇率', field: 'slot:customRate', width: '200px', permission: 'exchangeRate:update'},
          {id: 'lastDate', header: '更新时间', field: 'lastDate', minWidth: '200px'},
        ],
        month: new Date()
      }
    },
    methods: {
        // $gjQueryInitParams() {
        //     return {
        //         month: convertToMonth(new Date())
        //     };
        // },
        $gjQuery() {
            // 查询
            this.loading = true;
            getExchangeRatePage(convertToMonth(this.month))
                .then((data) => {
                    if (isMeaningful(data)) {
                        this.tableData = data;
                    }
                })
                .complete(() => {
                    this.loading = false;
                })
        },
      viewLog() {
        const modal = this.$gjCreate('gj-log-modal', {
          props: {
            url: '/base/exchangeRateLog/upCustomRate',
              columns: [
                  {id: 'createTime', header: '操作时间', field: 'createTime', minWidth: '120px'},
                  {id: 'userName', header: '操作用户', field: 'userName', minWidth: '100px'},
                  {id: 'operateType', header: '操作分类', field: this.opTypeOption ? 'option:op' : 'operateType', options: this.opTypeOption, minWidth: '120px'},
                  {id: 'details', header: '操作内容', field: 'details', overflowLine: 2, minWidth: '300px'},
              ]
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => modal.$gjDestroy()
          }
        });
      },
      updateMyExchangeRate(rate, row, closeEditor, closeLoading) {
          if (isMeaningless(rate) || isNaN(rate) || !RE.num(4).test(rate)) {
            closeLoading();
            this.$gjMessage.error('请输入有效的数值，最多保留四位小数');
            return;
          }
        updateCustomRate({id: row.id, customRate: rate})
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('操作成功');
              this.$gjNoticeQuery();
              closeEditor();
            })
          });
      },
      resetTable() {

      }
    }
  }
</script>

<style scoped>

</style>

